module.exports = __webpack_public_path__ + "static/media/book_b.63151611.jpg";